<template>
  <div class="article-list">
    <div class="article-tabs" v-if="articleGroup.length > 1">
      <div
        v-for="groupItem in articleGroup"
        :key="groupItem.category"
        class="article-tab"
        :class="curCategory === groupItem.category && 'is-active'"
        @click="curCategory = groupItem.category"
      >
        <span>{{ groupItem.category }}</span>
      </div>
    </div>
    <div class="article-ul">
      <a
        class="article-li single-ellipsis"
        v-for="(articleItem, articleIdx) in articleList"
        :key="articleIdx"
        :href="articleItem.link"
        target="_blank"
      >
        <span>{{ articleItem.title }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
export default {
  data() {
    return {
      articleGroup: [],
      curCategory: ''
    };
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    articleList() {
      const idx = this.articleGroup.findIndex(o => o.category === this.curCategory);
      return idx > -1 ? this.articleGroup[idx].list : [];
    }
  },
  mounted() {
    this.initHandle();
  },
  methods: {
    async initHandle() {
      try {
        const result = await services.courseware.getCourseCrime({
          size: 5000,
          query: { bool: { must: [{ term: { 'typename.keyword': `实证${this.type}` } }] } },
          sort: [{ sort: 'desc' }]
        });

        const list = result.hits.hits.map(item => item._source);

        const groupListEnum = [];
        const articleGroup = [];

        list.forEach(item => {
          if (!groupListEnum[item.category]) {
            groupListEnum[item.category] = [];
            articleGroup.push({ category: item.category, list: groupListEnum[item.category] });
          }
          groupListEnum[item.category].push(item);
        });

        this.curCategory = articleGroup[0] ? articleGroup[0].category : '';
        this.articleGroup = articleGroup;
      } catch (err) {
        this.$error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.article-list {
  background-color: #fff;
  margin-top: 14px;

  .article-tabs {
    height: 50px;
    line-height: 50px;
    color: #2c3443;
    font-size: 18px;
    border-bottom: 1px solid #e8ebef;
    padding: 0 30px;

    .article-tab {
      position: relative;
      display: inline-block;
      margin-right: 20px;
      cursor: pointer;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: #2c3443;
        visibility: hidden;
      }

      &.is-active {
        & > span {
          font-weight: 500;
        }
        &::after {
          visibility: visible;
        }
      }
    }
  }

  .article-ul {
    padding: 0 30px;
    .article-li {
      display: block;
      text-decoration: none;
      color: #2c3443;
      line-height: 22px;
      font-size: 16px;
      padding: 20px 0;
      border-bottom: 1px solid #e8ebef;
      cursor: pointer;
    }
  }
}
</style>
